import React, { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Card } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import SPopup from "../components/salesPopup";
import UserService from "../services/user-service";
import Popup from "reactjs-popup";
import GoalModal from "./GoalModal";
import { DatePicker } from "rsuite";
import Typography from "@mui/material/Typography";
import QuestionMark from "../assets/Icon/QuestionMark";
import { ReactComponent as EyeIcon } from "../assets/eyeIcon.svg";
import Popover from "@mui/material/Popover";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import "../styling/sidebar.css";
import "../styling/table.css";

interface CardViewProps {
  cardType?: any;
  selectedCardMonth?: any;
  loader?: any;
  nrows?: any;
  summary?: any;
  data?: any;
  calculateAmount?: any;
  checkSalesData: any;
  sideBar?: any;
  isTutorial?: boolean;
  currentMonthMaxProfit?: any;
  btnText?: any;
  selectedDate?: any;
}

const CardView: React.FC<CardViewProps> = ({
  cardType,
  selectedCardMonth,
  loader,
  nrows,
  summary,
  data,
  calculateAmount,
  checkSalesData,
  sideBar,
  isTutorial,
  currentMonthMaxProfit,
  btnText,
}) => {
  const [ucats, setucats] = useState([]);
  const allMonths = moment.monthsShort();
  const [open, setOpen] = useState(false);
  const [allStreamName, setAllStreamName] = useState([]);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const openModel = Boolean(anchorEl);

  allMonths.push('Year')
  
  useEffect(() => {
    UserService.getIncome().then((response) => {
      setucats(response.data.categories);
      var iname = response.data.iname.map((data, index) => {
        return {
          label: data,
          value: index,
        };
      });
      setAllStreamName(iname);
    });
    UserService.getSale().then((response) => {
      const saleCategoryValues = response.data.sale.map((item) => item.note);
      setucats(
        saleCategoryValues.filter(
          (item, index) => saleCategoryValues.indexOf(item) === index
        )
      );
    });
  }, []);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      color: "#48b7a7",
      padding: "10px 26px 10px 10px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
    "& .MuiSelect-icon": {
      fill:"#41c175"
    }
  }));

  return (
    data?.length &&
    data?.length >= 2 && (
      <Card className={sideBar ? `cards-sidebar` : `cards`}>
        <div className="d-flex justify-content-between align-items-center px-3 mt-3 mb-0 card-title-section">
          <div className="d-flex">
            <h4
              className={
                cardType === "Profit"
                  ? "card-profit-color"
                  : cardType === "Revenue"
                  ? "card-revenue-color"
                  : "card-expense-color"
              }
            >
              {cardType}
            </h4>
            <div>
              <Typography
                aria-owns={openModel ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              >
                <QuestionMark className="ml-3 mt-1" />
              </Typography>
              <Popover
                id="mouse-over-popover"
                sx={{
                  pointerEvents: "none",
                }}
                open={openModel}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
              >
                <Typography
                  sx={{ p: 1 }}
                  className="questionmark-popover text-white"
                >
                  {cardType === "Profit"
                    ? "Net Sales After Subtracting Expenses"
                    : cardType === "Revenue"
                    ? "Total Sales Including Expenses"
                    : cardType === "Expenses" &&
                      "Costs Involved In Running Your Business"}
                </Typography>
              </Popover>
            </div>
          </div>
          <FormControl sx={{ width: 100 }} defaultValue={0}>
            <Select
              id="month-option"
              className={
                cardType === "Profit"
                  ? "card-profit-color"
                  : cardType === "Revenue"
                  ? "card-revenue-color"
                  : "card-expense-color"
              }
              value={selectedCardMonth}
              onChange={(e) => calculateAmount(e.target.value, cardType)}
              fullWidth
              input={<BootstrapInput className="bootstrapInput" />}
            >
              {allMonths.map((item, index) => (
                <MenuItem key={item} value={index}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <hr className="my-2" />
        {loader && (
          <div className="card-loader">
            <CircularProgress
              style={{ color: "#48B7A7", alignContent: "center" }}
            />
          </div>
        )}
        {!loader && nrows.length === 0 ? (
          <div className="no-records-section">
            <h4>No Data Found</h4>
          </div>
        ) : (
          <>
            {!loader && (
              <>
                <div className="card-summary">
                  <p className="px-3">{summary}</p>
                </div>
                <hr className="my-2" />
              </>
            )}

            {cardType === "Revenue" && checkSalesData ? (
              <div className="card-data">
                <div className={data?.length <= 2 ? "mt-3" : "card-add-sale"}>
                  <p className="text-center h4">
                    {isTutorial ? (
                      <div>
                        <span className="add-sales-link"> Add a sales </span>
                        &nbsp;to start comparing
                      </div>
                    ) : (
                      <Popup
                        trigger={
                          <div>
                            <span className="add-sales-link"> Add a sale</span>
                            &nbsp;to start comparing
                          </div>
                        }
                        modal
                        nested
                      >
                        {(close) => (
                          <div className="mode">
                            <button className="close" onClick={close}>
                              &times;
                            </button>
                            <div className="header"> Add Sales</div>
                            <div className="content">
                              <SPopup categories={ucats} />
                              <br />
                            </div>
                          </div>
                        )}
                      </Popup>
                    )}
                  </p>
                  <p className="text-center h4">your profit vs. revenue vs.</p>
                  <p className="text-center h4">expenses.</p>
                </div>
              </div>
            ) : (
              <div
                className={
                  cardType === "Profit"
                    ? "card-profit-color card-data"
                    : cardType === "Revenue"
                    ? "card-revenue-color card-data"
                    : "card-expense-color card-data"
                }
              >
                {data.map((item, index) => (
                  <div
                    className="d-flex justify-content-between"
                    key={index}
                  >
                    <p className="px-3">{item.name}</p>
                    <p className="px-3">
                      {item.amount < 0 ? `-` : ``}
                      {`$${Math.abs(item.amount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </p>
                  </div>
                ))}
              </div>
            )}
            {(cardType === "Revenue" || cardType === "Expenses") && (
              <>
                <hr className="mt-0 mb-0" />
                <div className="d-flex justify-content-center">
                  <button
                    className={
                      cardType === "Revenue"
                        ? sideBar
                          ? "card-revenue-color card-goal-revenue-button-sidebar"
                          : "card-revenue-color card-goal-revenue-button"
                        : cardType === "Profit"
                        ? "card-revenue-color"
                        : sideBar
                        ? "card-expense-color card-goal-expense-button-sidebar"
                        : "card-expense-color card-goal-expense-button"
                    }
                    disabled={isTutorial}
                    onClick={() => {
                      setOpen(true);
                    }}
                  >
                    <EyeIcon />
                    {btnText
                      ? btnText
                      : cardType === "Revenue"
                      ? "View sales goals"
                      : "View expense caps"}
                  </button>
                  <GoalModal
                    open={open}
                    setOpen={setOpen}
                    nrows={nrows}
                    goalTitle={
                      cardType === "Revenue" ? "Sales Goal" : "Expense Cap"
                    }
                    content={
                      cardType === "Expenses" && "I want to spend maximum of"
                    }
                    goalButtonList={["Day", "Week", "Month", "Year"]}
                    addGoal={cardType === "Expenses" && "Add Expense cap"}
                    cardType={cardType === "Revenue" ? "Revenue" : "Expenses"}
                  />
                </div>
              </>
            )}
          </>
        )}
      </Card>
    )
  );
};

export default CardView;
